<template>
  <div class="dateContainer">
      <p class="m-0 p-0">{{ title }}</p>
      <div class="picker">
        <input type="date"
               placeholder="Data de inicio"
               ref="input"
               v-model="dateValue"
               class="datePicker"
               :class="with_error ? 'border-danger' : ''">
        <button class="icon-picker" @click="openCalendar">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M5 22q-.825 0-1.412-.587T3 20V6q0-.825.588-1.412T5 4h1V3q0-.425.288-.712T7 2q.425 0 .713.288T8 3v1h8V3q0-.425.288-.712T17 2q.425 0 .713.288T18 3v1h1q.825 0 1.413.588T21 6v14q0 .825-.587 1.413T19 22zm0-2h14V10H5zm7-6q-.425 0-.712-.288T11 13q0-.425.288-.712T12 12q.425 0 .713.288T13 13q0 .425-.288.713T12 14m-4 0q-.425 0-.712-.288T7 13q0-.425.288-.712T8 12q.425 0 .713.288T9 13q0 .425-.288.713T8 14m8 0q-.425 0-.712-.288T15 13q0-.425.288-.712T16 12q.425 0 .713.288T17 13q0 .425-.288.713T16 14m-4 4q-.425 0-.712-.288T11 17q0-.425.288-.712T12 16q.425 0 .713.288T13 17q0 .425-.288.713T12 18m-4 0q-.425 0-.712-.288T7 17q0-.425.288-.712T8 16q.425 0 .713.288T9 17q0 .425-.288.713T8 18m8 0q-.425 0-.712-.288T15 17q0-.425.288-.712T16 16q.425 0 .713.288T17 17q0 .425-.288.713T16 18" />
          </svg>
        </button>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Input',
  props: ['title', "currentValue", 'with_error'],
  emits: ['change'],
  data(){
    return {
      dateValue: ''
    }
  },
  methods:{
    openCalendar(){
      this.$refs.input.showPicker()
    },
    emitValue(){
      this.$emit('change', this.dateValue)
    }
  },
  watch: {
    dateValue: function(val){
      this.emitValue()
    }
  },
  mounted(){
    this.dateValue = this.currentValue || ''
  }
}
</script>

<style scoped>
.dateContainer {
  width: 100%;
  height: max-content;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.datePicker {
  padding: 0.5rem;
  height: 39px;
  font-size: 14px;
  
  background-color: white;
  border: 1px solid #d1d1d1;
  width: 100%;
}

.picker {
  position: relative;
  width: 100%;
  height: max-content;
}
.icon-picker{
  position: absolute;
  top: 1px;
  right: 1px;
  width: max-content;
  height: calc(100% - 2px);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
  padding: 0.55rem;
  background-color: transparent;
  outline: none;
  background-color: white;
}

*{
  color: #858796;
}
</style>
